import Color from '@/Enums/Color.enum';
import { IDoohFilterVenueType } from '@/Interfaces/Forecaster/Dooh.interface';
import { collectVisibleIds } from '@/helpers/forecaster/venueTypes';
import type { FilterVenueTypesNode } from '@/types/Forecaster/VenueNode.types';
import styled from '@emotion/styled';
import SearchIcon from '@mui/icons-material/Search';
import { Box, InputBase } from '@mui/material';
import { useMemo, useState } from 'react';
import VenueTypeColumn from './VenueTypeColumn';

const StyledInput = styled(InputBase)({
  padding: 10,
  width: '100%',
  position: 'relative',
  '& svg': {
    left: '26px',
    position: 'absolute',
  },
  '& input': {
    borderRadius: 8,
    backgroundColor: '#F1F3F4',
    padding: '12px 16px 12px 48px',
    fontSize: 14,
  },
});

interface IProps {
  nodes: FilterVenueTypesNode[];
  selected: IDoohFilterVenueType[];
  onChange: (id: FilterVenueTypesNode) => void;
}

const VenueTypePanel = ({ nodes, selected, onChange }: IProps) => {
  const [value, setValue] = useState<string>('');

  const visibleIds = useMemo(() => {
    if (!value.trim()) return null;
    return collectVisibleIds(nodes, value);
  }, [nodes, value]);

  return (
    <>
      <StyledInput
        startAdornment={<SearchIcon sx={{ color: Color.Grey }} />}
        autoFocus
        placeholder='Search..'
        value={value}
        onChange={e => setValue(e.target.value)}
        name='Venue Type Input'
      />
      <Box>
        {nodes.map(node => {
          if (visibleIds && !visibleIds.has(node.id)) return null;
          return (
            <VenueTypeColumn
              key={node.id}
              node={node}
              selected={selected}
              onChange={onChange}
              visibleIds={visibleIds}
            />
          );
        })}
      </Box>
    </>
  );
};

export default VenueTypePanel;
